// Public UI adapted from Klargo-Reference/content/legal/cookies.ts.
export const COOKIES_TITLE = 'Cookies och liknande tekniker';
export const COOKIES_INTRO = [
    { kind: 'paragraph', text: 'Klargo Technologies AB' },
    { kind: 'paragraph', text: 'Organisationsnummer: 559571-7736' },
    { kind: 'paragraph', text: 'Säte: Lidingö' },
    { kind: 'paragraph', text: 'E-post: info@klargo.se' },
    {
        kind: 'paragraph',
        text: 'Denna sida beskriver hur Klargo använder cookies och liknande tekniker på klargo.se och i Klargos webbapp.',
    },
    {
        kind: 'paragraph',
        text: 'Information om hur Klargo behandlar personuppgifter finns i vår integritetspolicy.',
    },
];
export const COOKIE_TABLE_COLUMNS = [
    'Namn',
    'Kategori',
    'Leverantör och part',
    'Typ',
    'Ändamål',
    'Information som används',
    'Varaktighet',
];
export const COOKIE_TABLE_ROWS = [
    [
        '[EXAKT NAMN]',
        '[Nödvändig/Analys/Funktion/Marknadsföring]',
        '[Klargo eller exakt tredje part]',
        '[Cookie/localStorage/sessionStorage/annan teknik]',
        '[Exakt och begripligt ändamål]',
        '[Vilken typ av information som lagras eller hämtas]',
        '[Session eller exakt tid]',
    ],
];
export const COOKIES_BLOCKS_BEFORE_TABLE = [
    { kind: 'section', text: '1. Vad är cookies och liknande tekniker?' },
    {
        kind: 'paragraph',
        text: 'Cookies, även kallade kakor, är små textfiler som kan sparas i din webbläsare när du besöker en webbplats.',
    },
    {
        kind: 'paragraph',
        text: 'Webbplatser och webbappar kan även använda liknande tekniker, exempelvis lokal lagring i webbläsaren. Sådan teknik kan användas för att komma ihåg en session, en inställning eller ett val som du har gjort.',
    },
    {
        kind: 'paragraph',
        text: 'På denna sida använder vi cookies som ett samlingsnamn för cookies och liknande tekniker som lagrar information på eller hämtar information från din enhet.',
    },
    {
        kind: 'paragraph',
        text: 'Information som endast behandlas i Klargos bakomliggande system, utan att lagras på eller hämtas från din enhet, beskrivs i integritetspolicyn.',
    },
    { kind: 'section', text: '2. Varför Klargo använder cookies' },
    { kind: 'paragraph', text: 'Klargo kan använda cookies för att:' },
    {
        kind: 'list',
        items: [
            'tillhandahålla grundläggande funktioner',
            'hantera inloggning och användarsessioner',
            'skydda tjänsten mot obehörig användning',
            'komma ihåg inställningar och val',
            'samla in statistik, om du har samtyckt till det',
            'genomföra andra tydligt angivna ändamål som du har samtyckt till',
        ],
    },
    {
        kind: 'paragraph',
        text: 'Vi använder inte cookies för ett annat ändamål än det som anges när informationen sparas eller hämtas.',
    },
    { kind: 'section', text: '3. Nödvändiga cookies' },
    { kind: 'paragraph', text: 'Nödvändiga cookies används endast när de krävs för att:' },
    {
        kind: 'list',
        items: [
            'överföra elektronisk kommunikation, eller',
            'tillhandahålla en funktion eller tjänst som du uttryckligen har begärt',
        ],
    },
    {
        kind: 'paragraph',
        text: 'Det kan exempelvis handla om cookies som behövs för att hålla dig inloggad, skydda en aktiv session eller komma ihåg ditt val om valfria cookies.',
    },
    {
        kind: 'paragraph',
        text: 'Nödvändiga cookies kräver inte ditt samtycke. De får dock inte användas för analys, marknadsföring eller andra ändamål bara för att sådana ändamål är användbara för Klargo.',
    },
    {
        kind: 'paragraph',
        text: 'Om du blockerar nödvändiga cookies i din webbläsare kan delar av webbplatsen eller webbappen sluta fungera.',
    },
    { kind: 'section', text: '4. Valfria cookies' },
    {
        kind: 'paragraph',
        text: 'Cookies som inte är nödvändiga aktiveras endast efter att du har lämnat ett giltigt samtycke.',
    },
    { kind: 'paragraph', text: 'Det kan exempelvis gälla cookies för:' },
    { kind: 'list', items: ['analys och statistik', 'valfria funktioner', 'marknadsföring'] },
    {
        kind: 'paragraph',
        text: 'Om Klargo använder sådana cookies ska du innan de aktiveras få tydlig information om:',
    },
    {
        kind: 'list',
        items: [
            'ändamålet',
            'vilken information som används',
            'vilken leverantör som använder tekniken',
            'om information delas med tredje part',
            'hur länge informationen sparas',
        ],
    },
    {
        kind: 'paragraph',
        text: 'Du ska kunna neka valfria cookies utan att förlora tillgång till Klargos grundläggande tjänst.',
    },
    { kind: 'section', text: '5. Cookies som Klargo använder' },
    {
        kind: 'paragraph',
        text: 'Nedan anges de cookies och liknande tekniker som faktiskt används på klargo.se och i Klargos webbapp.',
    },
];
export const COOKIES_BLOCKS_AFTER_TABLE = [
    {
        kind: 'paragraph',
        text: 'Tabellen ska alltid motsvara den teknik som faktiskt används.',
    },
    {
        kind: 'paragraph',
        text: 'Klargo ska inte använda en cookie eller liknande teknik som saknas i förteckningen, förutom rent tillfälliga tekniska funktioner som omfattas av undantaget för nödvändig kommunikation och som inte används för något annat ändamål.',
    },
    { kind: 'section', text: '6. Tredjepartscookies' },
    {
        kind: 'paragraph',
        text: 'En tredjepartscookie används av någon annan än Klargo, exempelvis en extern leverantör vars tjänst finns på Klargos webbplats eller i webbappen.',
    },
    {
        kind: 'paragraph',
        text: 'Om Klargo använder tredjepartscookies framgår det av tabellen ovan:',
    },
    {
        kind: 'list',
        items: [
            'vilken leverantör som använder tekniken',
            'vad den används till',
            'vilken information som behandlas',
            'hur länge den sparas',
        ],
    },
    {
        kind: 'paragraph',
        text: 'Tredjepartscookies som inte är nödvändiga aktiveras inte innan du har samtyckt till det aktuella ändamålet.',
    },
    {
        kind: 'paragraph',
        text: 'Den externa leverantören kan även behandla personuppgifter enligt sina egna villkor och sin egen integritetsinformation. Klargo ansvarar fortfarande för att informera om den tredjepartsteknik som Klargo väljer att använda på sin egen webbplats eller i sin webbapp.',
    },
    { kind: 'section', text: '7. Samtycke och dina val' },
    {
        kind: 'paragraph',
        text: 'När Klargo använder valfria cookies får du göra ett aktivt val innan de aktiveras.',
    },
    { kind: 'paragraph', text: 'Du ska kunna:' },
    {
        kind: 'list',
        items: [
            'acceptera valfria cookies',
            'neka valfria cookies',
            'välja separat mellan olika ändamål',
            'ändra ett tidigare val',
            'återkalla ett tidigare samtycke',
        ],
    },
    { kind: 'paragraph', text: 'Det ska vara lika enkelt att neka som att acceptera.' },
    {
        kind: 'paragraph',
        text: 'Fortsatt användning av webbplatsen, scrollning, stängning av en informationsruta eller andra passiva handlingar räknas inte som samtycke.',
    },
    {
        kind: 'paragraph',
        text: 'Om du inte gör något val får endast nödvändiga cookies användas.',
    },
    {
        kind: 'paragraph',
        text: 'Du kan när som helst ändra eller återkalla ditt val genom länken Cookies i sidfoten. När du återkallar ett samtycke ska den samtyckesbaserade användningen upphöra.',
    },
    { kind: 'section', text: '8. Webbläsarinställningar' },
    {
        kind: 'paragraph',
        text: 'Du kan även använda inställningarna i din webbläsare för att:',
    },
    {
        kind: 'list',
        items: [
            'visa sparade cookies',
            'radera cookies och annan webbläsarlagring',
            'blockera vissa eller samtliga cookies',
            'få information när en webbplats vill spara en cookie',
        ],
    },
    {
        kind: 'paragraph',
        text: 'Om du blockerar eller raderar nödvändiga cookies kan du exempelvis loggas ut eller förlora tillgång till funktioner som kräver en aktiv session.',
    },
    {
        kind: 'paragraph',
        text: 'Webbläsarens inställningar ersätter inte Klargos skyldighet att inhämta samtycke innan valfria cookies används.',
    },
    { kind: 'section', text: '9. Personuppgifter' },
    {
        kind: 'paragraph',
        text: 'Cookies kan innehålla eller ge upphov till behandling av personuppgifter.',
    },
    {
        kind: 'paragraph',
        text: 'När personuppgifter behandlas gäller även Klargos integritetspolicy. Där beskriver vi bland annat:',
    },
    {
        kind: 'list',
        items: [
            'vilka personuppgifter vi behandlar',
            'varför de behandlas',
            'vilken rättslig grund vi använder',
            'hur länge uppgifterna sparas',
            'vilka mottagare som kan få tillgång till dem',
            'dina rättigheter enligt dataskyddslagstiftningen',
        ],
    },
    { kind: 'section', text: '10. Ändringar' },
    { kind: 'paragraph', text: 'Klargo uppdaterar denna information när vi:' },
    {
        kind: 'list',
        items: [
            'börjar använda en ny cookie eller liknande teknik',
            'tar bort en teknik',
            'ändrar ett ändamål',
            'ändrar lagringstiden',
            'byter relevant leverantör',
            'ändrar hur information delas med tredje part',
        ],
    },
    {
        kind: 'paragraph',
        text: 'Om förändringen kräver ett nytt samtycke aktiveras inte den nya eller förändrade användningen innan du har fått information och lämnat ett nytt aktivt samtycke.',
    },
    {
        kind: 'paragraph',
        text: 'Datumet för den senaste uppdateringen anges högst upp på sidan.',
    },
    { kind: 'section', text: '11. Kontakt' },
    {
        kind: 'paragraph',
        text: 'Frågor om Klargos användning av cookies och liknande tekniker kan skickas till:',
    },
    { kind: 'paragraph', text: 'Klargo Technologies AB' },
    { kind: 'paragraph', text: 'Organisationsnummer: 559571-7736' },
    { kind: 'paragraph', text: 'E-post: info@klargo.se' },
];
export const COOKIES_UPDATED = 'Senast uppdaterad: 18 juli 2026';
